import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="pt-4 sm:pt-8 pb-14 px-4 overflow-hidden bg-brand-base relative" data-id="element-178">
      <div className="max-w-3xl mx-auto flex flex-col items-center relative z-10 mt-[-10px] mb-[-10px]" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 sm:px-4 sm:py-2 rounded-full bg-white/[0.04] border border-brand-gold/30 text-brand-gold font-semibold text-xs sm:text-sm mb-3 sm:mb-6 backdrop-blur-sm glow-gold" data-id="element-180">
          <span data-id="element-181">🌾</span> www.impulsodigitalstore.com
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-display tracking-tight mb-2 text-[28px] sm:text-[44px] lg:text-[56px] leading-[1.08]" data-id="element-182">
          <span className="block font-bold text-brand-gold glow-gold text-[24px]" data-id="element-183">
            Volvé a Comer Pan y Postres
          </span>
          <span className="block italic font-semibold text-brand-gold/95 mt-1 glow-gold text-[20px]" data-id="element-184">
            sin picos de glucosa.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-base sm:text-2xl lg:text-3xl font-bold text-brand-cream mb-2 sm:mb-3 leading-tight tracking-wide" data-id="element-185">
          Listo. Desde hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative w-full max-w-[330px] sm:max-w-lg lg:max-w-xl mb-3 sm:mb-4 mt-2" data-id="element-186">
          <img src="https://cdn.magicpatterns.com/uploads/ufbLZvu6SrHDC8YRVUGsKW/ChatGPT_Image_20_may_2026__12_57_12-removebg-preview.png" alt="Megapack Cocina Sin Gluten y Sin Azúcar" className="relative z-10 w-full h-auto mt-[-12px] mb-[-12px]" style={{
          filter: 'drop-shadow(0 14px 24px rgba(0, 0, 0, 0.45))'
        }} data-id="element-187" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="flex flex-col items-center max-w-sm sm:max-w-lg px-2 sm:px-6 mt-1 mb-3 sm:mb-4 gap-2 sm:gap-3" data-id="element-188">
          <p className="text-[15px] sm:text-xl leading-[1.25] text-center text-brand-cream font-semibold pt-[-10px] pb-[-10px]" data-id="element-189">
            El sistema <span className="text-brand-gold font-bold" data-id="element-190">N°1</span>{' '}
            para comer rico
            <br data-id="element-191" />
            sin gluten, sin azúcar y sin miedo a la glucosa.
          </p>
          <p className="text-[11px] sm:text-[13px] leading-snug text-center text-brand-cream/70 font-normal" data-id="element-192">
            +400 recetas rápidas, económicas y fáciles.
          </p>

          <ul className="flex flex-nowrap items-center justify-center gap-1 sm:gap-2 mt-0.5 w-full" data-id="element-193">
            {[{
            icon: '📄',
            label: '100% PDF'
          }, {
            icon: '⚡',
            label: '5 min'
          }, {
            icon: '🍞',
            label: 'Panes reales'
          }, {
            icon: '🎁',
            label: '6 Bonos'
          }].map(chip => <li key={chip.label} className="inline-flex items-center gap-1 rounded-full border border-brand-gold/35 bg-white/[0.04] px-2 py-1 text-[10px] sm:text-xs font-semibold text-brand-cream whitespace-nowrap" data-id="element-194">
                <span aria-hidden className="text-[11px] sm:text-sm" data-id="element-195">
                  {chip.icon}
                </span>
                <span data-id="element-196">{chip.label}</span>
              </li>)}
          </ul>
        </motion.div>

        <div className="relative inline-block mb-4 sm:mb-5" data-id="element-197">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToPricing} className="bg-brand-gold text-brand-base font-bold text-base sm:text-lg py-3.5 px-8 sm:py-4 sm:px-10 rounded-xl hover:bg-[#C29A35] transition-colors relative z-10 uppercase tracking-wide" data-id="element-198">
            QUIERO MI MEGAPACK AHORA
          </motion.button>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-x-3 sm:gap-x-6 text-[11px] sm:text-sm font-medium text-brand-cream/70 mb-8 whitespace-nowrap" data-id="element-199">
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-200">
            <Shield size={14} className="text-brand-gold shrink-0 sm:size-4" data-id="element-201" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-202">
            <Lock size={14} className="text-brand-gold shrink-0 sm:size-4" data-id="element-203" />{' '}
            Pago seguro
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-204">
            <CreditCard size={14} className="text-brand-gold shrink-0 sm:size-4" data-id="element-205" />{' '}
            Mercado Pago
          </span>
        </div>

        <div className="gold-divider w-full max-w-md mb-6" data-id="element-206"></div>
      </div>
    </section>;
}